import { motion } from 'framer-motion';
import { useState } from 'react';
import { FiCheck, FiCopy, FiGithub, FiLinkedin, FiMail, FiPhone } from 'react-icons/fi';
import GlassCard from '../shared/GlassCard';

export default function Contact({ handleSubmit, contactStatus, isSubmitting }) {
  const [emailCopyState, setEmailCopyState] = useState('idle');

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText('sshambhavi89@gmail.com');
      setEmailCopyState('copied');
      window.setTimeout(() => setEmailCopyState('idle'), 2000);
    } catch {
      setEmailCopyState('unavailable');
    }
  };

  return (
        <section
          id="contact"
          className="py-16 px-4 sm:px-6 md:px-20 bg-indigo-50/30 dark:bg-gray-800/30"
        >

          <div className="max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, type: "spring" }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-10 text-gray-900 dark:text-white text-center">
                <span className="border-b-4 border-indigo-500 pb-1">Get In Touch</span>
              </h2>

              <GlassCard className="p-4 sm:p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                  <div>
                    <h3 className="text-2xl font-semibold text-indigo-800 dark:text-indigo-300 mb-4">Let's Connect</h3>
                    <p className="text-lg mb-6">
                      Have a project, role, or opportunity in mind? I’m always open to meaningful discussions and collaborations.
                    </p>

                    <div className="space-y-4">
                      <motion.div
                        className="flex items-center gap-4 p-4 rounded-lg hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition"
                        whileHover={{ x: 5 }}
                      >
                        <div className="p-3 bg-indigo-100 dark:bg-gray-700 rounded-full">
                          <FiMail className="text-indigo-600 dark:text-indigo-400 text-xl" />
                        </div>
                        <div>
                          <h4 className="font-medium">Email</h4>
                          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                            <a href="mailto:sshambhavi89@gmail.com" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                              sshambhavi89@gmail.com
                            </a>
                            <button
                              type="button"
                              onClick={copyEmail}
                              className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold text-indigo-700 transition hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-indigo-300 dark:hover:bg-gray-700"
                              aria-label={emailCopyState === 'copied' ? 'Email address copied' : 'Copy email address'}
                            >
                              {emailCopyState === 'copied' ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}
                              {emailCopyState === 'copied' ? 'Copied' : 'Copy'}
                            </button>
                          </div>
                          {emailCopyState === 'unavailable' && (
                            <p role="status" className="mt-1 text-xs text-gray-500 dark:text-gray-400">Copy is unavailable here; you can select the address above.</p>
                          )}
                        </div>
                      </motion.div>

                      <motion.div
                        className="flex items-center gap-4 p-4 rounded-lg hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition"
                        whileHover={{ x: 5 }}
                      >
                        <div className="p-3 bg-indigo-100 dark:bg-gray-700 rounded-full">
                          <FiPhone className="text-indigo-600 dark:text-indigo-400 text-xl" />
                        </div>
                        <div>
                          <h4 className="font-medium">Phone</h4>
                          <a
                            href="tel:+919380250104"
                            className="text-indigo-600 dark:text-indigo-400 hover:underline"
                          >
                            +91 9380250104
                          </a>
                        </div>
                      </motion.div>

                      <motion.div
                        className="flex items-center gap-4 p-4 rounded-lg hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition"
                        whileHover={{ x: 5 }}
                      >
                        <div className="p-3 bg-indigo-100 dark:bg-gray-700 rounded-full">
                          <FiLinkedin className="text-indigo-600 dark:text-indigo-400 text-xl" />
                        </div>
                        <div>
                          <h4 className="font-medium">LinkedIn</h4>
                          <a
                            href="https://www.linkedin.com/in/shambhavi-singh2023"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-indigo-600 dark:text-indigo-400 hover:underline"
                          >
                            https://www.linkedin.com/in/shambhavi-singh2023
                          </a>
                        </div>
                      </motion.div>

                      <motion.div
                        className="flex items-center gap-4 p-4 rounded-lg hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition"
                        whileHover={{ x: 5 }}
                      >
                        <div className="p-3 bg-indigo-100 dark:bg-gray-700 rounded-full">
                          <FiGithub className="text-indigo-600 dark:text-indigo-400 text-xl" />
                        </div>
                        <div>
                          <h4 className="font-medium">GitHub</h4>
                          <a
                            href="https://github.com/ShambhaviSingh16"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-indigo-600 dark:text-indigo-400 hover:underline"
                          >
                            https://github.com/ShambhaviSingh16
                          </a>
                        </div>
                      </motion.div>
                      <motion.div
                        className="flex items-center gap-4 p-4 rounded-lg hover:bg-indigo-50/50 dark:hover:bg-gray-700/50 transition"
                        whileHover={{ x: 5 }}
                      >
                        <div className="p-3 bg-indigo-100 dark:bg-gray-700 rounded-full">
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/1/19/LeetCode_logo_black.png"
                            alt="LeetCode"
                            className="w-5 h-5 object-contain"
                          />
                        </div>

                        <div>
                          <h4 className="font-medium">LeetCode</h4>
                          <a
                            href="https://leetcode.com/u/ShambhaviSingh16/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-indigo-600 dark:text-indigo-400 hover:underline"
                          >
                            https://leetcode.com/u/ShambhaviSingh16/
                          </a>
                        </div>
                      </motion.div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-semibold text-indigo-800 dark:text-indigo-300 mb-4">Send Me a Message</h3>
                    {contactStatus && (
                      <div
                        role={contactStatus.type === 'error' ? 'alert' : 'status'}
                        aria-live={contactStatus.type === 'error' ? 'assertive' : 'polite'}
                        className={`mb-4 rounded-xl border p-4 text-sm leading-relaxed ${contactStatus.type === 'success'
                          ? 'border-green-300 bg-green-50 text-green-900 dark:border-green-800 dark:bg-green-950/40 dark:text-green-200'
                          : 'border-red-300 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950/40 dark:text-red-200'
                          }`}
                      >
                        <p>{contactStatus.message}</p>
                        {contactStatus.type === 'error' && (
                          <a href="mailto:sshambhavi89@gmail.com" className="mt-2 inline-block font-semibold underline underline-offset-2">
                            sshambhavi89@gmail.com
                          </a>
                        )}
                      </div>
                    )}
                    <form
                      onSubmit={handleSubmit}
                      className="space-y-4"
                    >
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium mb-1">Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          className="w-full px-4 py-2 bg-white/50 dark:bg-gray-700/50 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Your name"
                        />
                      </div>

                      <div>
                        <label htmlFor="email" className="block text-sm font-medium mb-1">Email</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          className="w-full px-4 py-2 bg-white/50 dark:bg-gray-700/50 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="example@gmail.com"
                        />
                      </div>

                      <div>
                        <label htmlFor="subject" className="block text-sm font-medium mb-1">Subject</label>
                        <input
                          type="text"
                          id="subject"
                          name="title"
                          required
                          className="w-full px-4 py-2 bg-white/50 dark:bg-gray-700/50 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Subject"
                        />
                      </div>

                      <div>
                        <label htmlFor="message" className="block text-sm font-medium mb-1">Message</label>
                        <textarea
                          id="message"
                          name="message"
                          rows="4"
                          required
                          className="w-full px-4 py-2 bg-white/50 dark:bg-gray-700/50 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Your message here..."
                        ></textarea>
                      </div>

                      <motion.button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-indigo-600 text-white font-semibold px-6 py-3 rounded-lg shadow hover:bg-indigo-700 disabled:cursor-wait disabled:opacity-70 dark:bg-indigo-500 dark:hover:bg-indigo-600 transition"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        {isSubmitting ? 'Sending…' : 'Send Message'}
                      </motion.button>
                    </form>
                  </div>
                </div>
              </GlassCard>
            </motion.div>
          </div>
        </section>
  );
}
